module.exports = __webpack_public_path__ + "static/media/Inter-Thin.0f080c40.woff";